import { Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import FieldContainer from '../../../FormFields/FieldContainer';
import FormButtonOptions from '../../../FormFields/FormButtonOptions';
import FormDataDivider from '../../../FormFields/FormDataDivider';
import FormMoneyField from '../../../FormFields/FormMoneyField';
import FormNumberField from '../../../FormFields/FormNumberField';
import FormTitle from '../../../FormFields/FormTitle';
import FormVendorField from '../../../FormFields/FormVendorField';
import { FILE_TYPES } from '../../../formFileTypesEnum';
import { HR } from '../../../formQuestionsEnum';
import { OUTSOURCED_COMPANY_CATEGORIES } from '../../../optionEnums';

HousekeepingSection.propTypes = {
  permissions: PropTypes.object,
};

export default function HousekeepingSection({ permissions }) {
  const {
    data: { outsourcedCompanyCategoriesList },
  } = useSelector((state) => state.transitions);
  const { watch } = useFormContext();
  const isOutsourced = watch(HR.HOUSEKEEPING_IS_OUTSOURCED.fieldName);
  const [focusedField, setFocusedField] = useState(null);

  return (
    [
      HR.HOUSEKEEPING_IS_OUTSOURCED.id,
      HR.HOUSEKEEPING_OUTSOURCED_CATEGORY_ID.id,
      HR.HOUSEKEEPING_OUTSOURCED_HOURS_PER_WEEK.id,
      HR.HOUSEKEEPING_AVERAGE_MONTHLY_COST.id,
      HR.HOUSEKEEPING_AND_LAUNDRY_OUTSOURCE_VENDOR.id,
      HR.HOUSEKEEPING_OUTSOURCED_COMP_HAS_HR_FILES.id,
    ].some((id) => id in permissions) && (
      <>
        <Grid item xs={12}>
          <Typography variant="subtitle1" color="text.secondary">
            Housekeeping
          </Typography>
        </Grid>
        {HR.HOUSEKEEPING_IS_OUTSOURCED.id in permissions && (
          <Grid item xs={12} lg={4}>
            <FieldContainer>
              <FormTitle fieldAttributes={{ questionTitle: 'Department type' }} />
              <FormButtonOptions
                fieldName={HR.HOUSEKEEPING_IS_OUTSOURCED.fieldName}
                fieldAttributes={{
                  isEditable: permissions[HR.HOUSEKEEPING_IS_OUTSOURCED.id],
                  options: [
                    { label: 'Outsourced', value: true },
                    { label: 'In House', value: false },
                  ],
                }}
              />
            </FieldContainer>
          </Grid>
        )}

        {isOutsourced === true && (
          <>
            {HR.HOUSEKEEPING_OUTSOURCED_CATEGORY_ID.id in permissions && (
              <Grid item xs={12}>
                <FieldContainer>
                  <FormTitle fieldAttributes={{ questionTitle: 'Choose Category' }} />
                  <FormButtonOptions
                    fieldName={HR.HOUSEKEEPING_OUTSOURCED_CATEGORY_ID.fieldName}
                    fieldAttributes={{
                      isEditable: permissions[HR.HOUSEKEEPING_OUTSOURCED_CATEGORY_ID.id],
                      options: outsourcedCompanyCategoriesList.filter(
                        (x) =>
                          x.value === OUTSOURCED_COMPANY_CATEGORIES.FULL_DEPARTMENT ||
                          x.value === OUTSOURCED_COMPANY_CATEGORIES.MANAGER_ONLY
                      ),
                    }}
                  />
                </FieldContainer>
              </Grid>
            )}

            {HR.HOUSEKEEPING_OUTSOURCED_HOURS_PER_WEEK.id in permissions && (
              <Grid item xs={12} lg={6}>
                <FieldContainer>
                  <FormTitle fieldAttributes={{ questionTitle: 'Hours per week' }} />
                  <FormNumberField
                    fieldName={HR.HOUSEKEEPING_OUTSOURCED_HOURS_PER_WEEK.fieldName}
                    fieldAttributes={{
                      isEditable: permissions[HR.HOUSEKEEPING_OUTSOURCED_HOURS_PER_WEEK.id],
                    }}
                    focusedField={focusedField}
                    setFocusedField={setFocusedField}
                    allowDecimal
                  />
                </FieldContainer>
              </Grid>
            )}
            {HR.HOUSEKEEPING_AVERAGE_MONTHLY_COST.id in permissions && (
              <Grid item xs={12} lg={6}>
                <FieldContainer>
                  <FormTitle fieldAttributes={{ questionTitle: 'Average monthly cost' }} />
                  <FormMoneyField
                    fieldName={HR.HOUSEKEEPING_AVERAGE_MONTHLY_COST.fieldName}
                    fieldAttributes={{
                      isEditable: permissions[HR.HOUSEKEEPING_AVERAGE_MONTHLY_COST.id],
                    }}
                    focusedField={focusedField}
                    setFocusedField={setFocusedField}
                  />
                </FieldContainer>
              </Grid>
            )}
            {HR.HOUSEKEEPING_AND_LAUNDRY_OUTSOURCE_VENDOR.id in permissions && (
              <Grid item xs={12}>
                <FieldContainer>
                  <FormTitle
                    fieldAttributes={{
                      questionTitle: 'Housekeeping and laundry outsourced company',
                      fieldType: 'title',
                    }}
                  />
                  <FormVendorField
                    fieldName={HR.HOUSEKEEPING_AND_LAUNDRY_OUTSOURCE_VENDOR.fieldName}
                    fieldAttributes={{ isEditable: permissions[HR.HOUSEKEEPING_AND_LAUNDRY_OUTSOURCE_VENDOR.id] }}
                    invoiceFileTypeId={FILE_TYPES.HOUSEKEEPING_AND_LAUNDRY_OUTSOURCED_COMPANY_INVOICE}
                    contractFileTypeId={FILE_TYPES.HOUSEKEEPING_AND_LAUNDRY_OUTSOURCED_COMPANY_CONTRACT}
                  />
                </FieldContainer>
              </Grid>
            )}
            {HR.HOUSEKEEPING_OUTSOURCED_COMP_HAS_HR_FILES.id in permissions && (
              <Grid item xs={12}>
                <FormTitle
                  fieldAttributes={{ questionTitle: 'Does the contracted company have their own HR files?' }}
                />
                <FormButtonOptions
                  fieldName={HR.HOUSEKEEPING_OUTSOURCED_COMP_HAS_HR_FILES.fieldName}
                  fieldAttributes={{
                    isEditable: permissions[HR.HOUSEKEEPING_OUTSOURCED_COMP_HAS_HR_FILES.id],
                    options: [
                      { label: 'Yes', value: true },
                      { label: 'No', value: false },
                    ],
                  }}
                />
              </Grid>
            )}
          </>
        )}
        <FormDataDivider />
      </>
    )
  );
}
